import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export interface DataAccessOrdersConfig {
  unableToDownloadComponent: ComponentType<unknown>;
}

export const DATA_ACCESS_ORDERS_CONFIG =
  new InjectionToken<DataAccessOrdersConfig>('DATA_ACCESS_ORDERS_CONFIG');
